import type { ProjectDetail } from '@/stores/project/types';
import DefaultSiteThumbnail from '@/components/DefaultSiteThumbnail';
import { formatProjectLastActive } from '@/pages/Workspace/components/ProjectCard/helper';
import PublishStatusBadge from '@/pages/Workspace/components/ProjectCard/PublishStatusBadge';
import { PublishStatus } from '@/services/project';
import { ProjectStatus } from '@/stores/project';
import styles from './index.module.less';

interface RecentProjectPreviewCardProps {
  project: ProjectDetail;
}

function RecentProjectPreviewCard(props: RecentProjectPreviewCardProps) {
  const { project } = props;
  const title = project.name;
  const publishStatus = project.publishInfo?.status || PublishStatus.NotPublished;
  const shouldShowThumbnail = project.status !== ProjectStatus.PENDING && project.thumbnailUrl;

  return (
    <div className={styles['project-preview-card']}>
      <div className={styles['project-preview-thumbnail']}>
        <div className={styles['project-preview-thumbnail-img']}>
          <div className={styles['project-preview-thumbnail-img-container']}>
            {shouldShowThumbnail ? (
              <img className={styles['project-preview-cover']} src={project.thumbnailUrl || ''} alt={title} />
            ) : (
              <div className={styles['project-preview-thumbnail-placeholder']}>
                <DefaultSiteThumbnail />
              </div>
            )}
            <div className={styles['project-preview-status']}>
              <PublishStatusBadge status={publishStatus} />
            </div>
          </div>
        </div>
      </div>
      <div className={styles['project-preview-bottom']}>
        <div className={styles['project-preview-title']} title={title}>
          {title}
        </div>
        <div className={styles['project-preview-time']}>{formatProjectLastActive(project)}</div>
      </div>
    </div>
  );
}

export default RecentProjectPreviewCard;
